import { Provider, createStore } from "jotai";

export const JotaiStore = createStore();

export { Provider as JotaiProvider };
